import React from 'react';
import { RefreshCw } from 'lucide-react';
import { useRerunModule } from '../hooks/useModuleData';

export default function RerunButton({ moduleId }) {
  const { mutate, isPending, isSuccess } = useRerunModule(moduleId);

  return (
    <button
      onClick={() => mutate()}
      disabled={isPending}
      className="flex items-center gap-2 px-4 py-2 rounded-xl bg-white/10 hover:bg-white/20
        active:scale-95 transition-all duration-150 text-sm font-medium disabled:opacity-50"
    >
      <RefreshCw size={14} className={isPending ? 'animate-spin' : ''} />
      {isPending ? 'Running...' : isSuccess ? 'Done!' : 'Re-run'}
    </button>
  );
}
